import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { CountryCollectionModel } from "@insite/client-framework/Types/ApiModels";

const customUrl = '/api/v1/customApis'

export function ucsGetCountriesAndStates(parameter: ApiParameter) {
    return get<CountryCollectionModel>(`${customUrl}/countriesAndStates`, parameter);
}
